module.exports = __webpack_public_path__ + "img/OVCA_TMKI67.e2c26f12.png";